import { Nullable } from "@/api/ApiClient";

export type ProviderFormData = Nullable<{
    id: string | undefined;
    codigo: string,
    nombre: string,
    nombre_comercial: string,
    telefono1_cd: string,
    telefono1: string,
    telefono2_cd: string,
    telefono2: string,
    shipping: number,
    direccion: string,
    cuentas_bancarias: string,
    contacto: string,
    tipo_identificacion: string,
    identificacion: string,
    email: string,
    tipo: number,
    plazo: number,
    providerInvoices: any[],
    providerRecibes: any[]
}>;

export const ProviderRelatedAttributes: Array<keyof ProviderFormData> = ["providerInvoices", "providerRecibes"];